export enum OrganisationView {
  ALL = 'ALL',
  ADDED = 'ADDED',
}
